// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.active-modal {
    /* overflow-y: hidden; */
}

.btn-modal {
    padding: 8px 10px;
    display: block;
    margin: 100px auto 0;
    font-size: 18px;
}

.modal, .overlay {
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    z-index: 2001;
}

.overlay {
    background: rgba(49,49,49,0.8);
}

.modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  padding: 14px 28px;
  border-radius: 10px;
  min-width: 300px;
  z-index: 2002;
}

.modal-content-detail {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  background: #ffffff;
  padding: 14px 28px;
  border-radius: 3px;
  width: auto;
  min-width: 300px;
  z-index: 2002;
  overflow: auto;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
}

.modal-content-detail-filter {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  background: #ffffff;
  padding: 14px 28px;
  border-radius: 3px;
  width: 100vw; /* Set width to match the viewport width */
  max-width: 80%; /* Set a maximum width if necessary */
  z-index: 2002;
  overflow-y: auto;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
}

.close-modal {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 5px 7px;
}

.btn_close-modal {
  padding: 8px 10px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.btn-modal-filter {
    padding: 4px 10px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }
  .btn_delete{
    background-color: #ff002f;
    color: #ffffff;
  }
  .btn_add{
    background-color: #42c5f5;
    color: #ffffff;
  }
  .btn_close{
    background-color: #f12f11;
    color: #ffffff;
  }
  .btn_upload{
    background-color: #3498db;
    color: #ffffff;
  }
  .btn_download{
    background-color: #06b23f;
    color: #ffffff;
  }
  
  .btn_close-modal:hover {
    background-color: #2980b9;
  }

  .container {
    display: flex;
  }
  
  .leftDiv {
    flex: 1 1; /* Takes up the available space */
    background-color: #e0e0e0; /* Example background color */
    padding: 20px;
    border-radius: 5px 0px 0px 5px;
  }
  
  .rightDiv {
    background-color: #f0f0f0; /* Example background color */
    padding: 20px;
    border-radius: 0px 5px 5px 0px;
  }

  .welcome-container {
    display: flex;
    align-items: left;
    justify-content: left;
    text-align: left;
  }
  
  .welcome-image {
    max-width: 10%;
    height: auto;
    border-radius: 50%; /* Optional: Add rounded corners to the image */
  }
  
  .welcome-text {
    margin-left: 5px; /* Optional: Adjust the spacing between image and text */
  }
  
  /* Additional styling for text (adjust as needed) */
  .welcome-text h1 {
    font-size: 24px;
  }
  
  .welcome-text p {
    margin-top: -5px;
    font-size: 14px;
    color: #555;
  }

  .flex-container {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 5px;
}

  .flex-item {
    flex: 1 1 48%; /* Adjust as needed */
    margin: 10px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 8px;
    height: 500px;
    background-color: #efefef;
    z-index: 2004;
  }

  .packbutton{
    /* margin-top: -60px; */
    margin-top: 4px;
  }

  .close-botton-top{
    display: none;
  }

  /* Media queries for responsiveness */
  @media (max-width: 1390px) {
    .close-botton-top{
      display: block;
    }

    .flex-container {
      flex-direction: column; /* Stack items vertically on smaller screens */
      align-items: stretch; /* Stretch items to full width */
    }

    .flex-item {
      flex-basis: auto; /* Auto width on smaller screens */
    }

    .modal-content {
      position: absolute;
      top: 70%;
      left: 50%;
      transform: translate(-50%, -45%);
      line-height: 1.4;
      padding: 14px 28px;
      border-radius: 10px;
      min-width: 300px;
      z-index: 2002;
  }
  }`, "",{"version":3,"sources":["webpack://./src/css/Modal.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,4IAA4I;AAC9I;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY,EAAE,0CAA0C;EACxD,cAAc,EAAE,qCAAqC;EACrD,aAAa;EACb,gBAAgB;EAChB,4IAA4I;AAC9I;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAO,EAAE,iCAAiC;IAC1C,yBAAyB,EAAE,6BAA6B;IACxD,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,yBAAyB,EAAE,6BAA6B;IACxD,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,kBAAkB,EAAE,+CAA+C;EACrE;;EAEA;IACE,gBAAgB,EAAE,wDAAwD;EAC5E;;EAEA,mDAAmD;EACnD;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;AACtB;;EAEE;IACE,aAAa,EAAE,qBAAqB;IACpC,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA,qCAAqC;EACrC;IACE;MACE,cAAc;IAChB;;IAEA;MACE,sBAAsB,EAAE,8CAA8C;MACtE,oBAAoB,EAAE,gCAAgC;IACxD;;IAEA;MACE,gBAAgB,EAAE,kCAAkC;IACtD;;IAEA;MACE,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,gCAAgC;MAChC,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;MAChB,aAAa;EACjB;EACA","sourcesContent":["body.active-modal {\n    /* overflow-y: hidden; */\n}\n\n.btn-modal {\n    padding: 8px 10px;\n    display: block;\n    margin: 100px auto 0;\n    font-size: 18px;\n}\n\n.modal, .overlay {\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    position: fixed;\n    z-index: 2001;\n}\n\n.overlay {\n    background: rgba(49,49,49,0.8);\n}\n\n.modal-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  line-height: 1.4;\n  padding: 14px 28px;\n  border-radius: 10px;\n  min-width: 300px;\n  z-index: 2002;\n}\n\n.modal-content-detail {\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  line-height: 1.4;\n  background: #ffffff;\n  padding: 14px 28px;\n  border-radius: 3px;\n  width: auto;\n  min-width: 300px;\n  z-index: 2002;\n  overflow: auto;\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;\n}\n\n.modal-content-detail-filter {\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  line-height: 1.4;\n  background: #ffffff;\n  padding: 14px 28px;\n  border-radius: 3px;\n  width: 100vw; /* Set width to match the viewport width */\n  max-width: 80%; /* Set a maximum width if necessary */\n  z-index: 2002;\n  overflow-y: auto;\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;\n}\n\n.close-modal {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    padding: 5px 7px;\n}\n\n.btn_close-modal {\n  padding: 8px 10px;\n  border: none;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.btn-modal-filter {\n    padding: 4px 10px;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n  }\n  .btn_delete{\n    background-color: #ff002f;\n    color: #ffffff;\n  }\n  .btn_add{\n    background-color: #42c5f5;\n    color: #ffffff;\n  }\n  .btn_close{\n    background-color: #f12f11;\n    color: #ffffff;\n  }\n  .btn_upload{\n    background-color: #3498db;\n    color: #ffffff;\n  }\n  .btn_download{\n    background-color: #06b23f;\n    color: #ffffff;\n  }\n  \n  .btn_close-modal:hover {\n    background-color: #2980b9;\n  }\n\n  .container {\n    display: flex;\n  }\n  \n  .leftDiv {\n    flex: 1; /* Takes up the available space */\n    background-color: #e0e0e0; /* Example background color */\n    padding: 20px;\n    border-radius: 5px 0px 0px 5px;\n  }\n  \n  .rightDiv {\n    background-color: #f0f0f0; /* Example background color */\n    padding: 20px;\n    border-radius: 0px 5px 5px 0px;\n  }\n\n  .welcome-container {\n    display: flex;\n    align-items: left;\n    justify-content: left;\n    text-align: left;\n  }\n  \n  .welcome-image {\n    max-width: 10%;\n    height: auto;\n    border-radius: 50%; /* Optional: Add rounded corners to the image */\n  }\n  \n  .welcome-text {\n    margin-left: 5px; /* Optional: Adjust the spacing between image and text */\n  }\n  \n  /* Additional styling for text (adjust as needed) */\n  .welcome-text h1 {\n    font-size: 24px;\n  }\n  \n  .welcome-text p {\n    margin-top: -5px;\n    font-size: 14px;\n    color: #555;\n  }\n\n  .flex-container {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 10px 10px 10px;\n    box-sizing: border-box;\n    background-color: #fff;\n    border-radius: 5px;\n}\n\n  .flex-item {\n    flex: 1 1 48%; /* Adjust as needed */\n    margin: 10px;\n    padding: 20px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    height: 500px;\n    background-color: #efefef;\n    z-index: 2004;\n  }\n\n  .packbutton{\n    /* margin-top: -60px; */\n    margin-top: 4px;\n  }\n\n  .close-botton-top{\n    display: none;\n  }\n\n  /* Media queries for responsiveness */\n  @media (max-width: 1390px) {\n    .close-botton-top{\n      display: block;\n    }\n\n    .flex-container {\n      flex-direction: column; /* Stack items vertically on smaller screens */\n      align-items: stretch; /* Stretch items to full width */\n    }\n\n    .flex-item {\n      flex-basis: auto; /* Auto width on smaller screens */\n    }\n\n    .modal-content {\n      position: absolute;\n      top: 70%;\n      left: 50%;\n      transform: translate(-50%, -45%);\n      line-height: 1.4;\n      padding: 14px 28px;\n      border-radius: 10px;\n      min-width: 300px;\n      z-index: 2002;\n  }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
